import React, { useState, useEffect } from 'react';
import { adminUsersAPI } from '../api';
import { getAdmin } from '../auth';
import './AdminUsers.css';

const AdminUsers = () => {
  const [adminUsers, setAdminUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentAdmin, setCurrentAdmin] = useState(null);

  useEffect(() => {
    const admin = getAdmin();
    setCurrentAdmin(admin);
    
    if (admin && admin.role === 'super_admin') {
      loadAdminUsers();
    } else {
      setError('Только super_admin может просматривать администраторов');
      setLoading(false);
    }
  }, []);

  const loadAdminUsers = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await adminUsersAPI.getAdminUsers();
      setAdminUsers(response.data.admin_users || []);
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка загрузки администраторов');
    } finally {
      setLoading(false);
    }
  };

  if (!currentAdmin || currentAdmin.role !== 'super_admin') {
    return (
      <div className="admin-users">
        <div className="error">
          У вас нет прав для просмотра администраторов. Требуется роль super_admin.
        </div>
      </div>
    );
  }

  return (
    <div className="admin-users">
      <header className="page-header">
        <h1>Управление администраторами</h1>
      </header>

      <div className="container-fluid">
        {error && <div className="error">{error}</div>}
        
        {loading && <div className="loading">Загрузка...</div>}
        
        {!loading && (
          <div className="card">
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Username</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>2FA</th>
                  <th>Active</th>
                  <th>Last Login</th>
                </tr>
              </thead>
              <tbody>
                {adminUsers.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="no-data">Нет администраторов</td>
                  </tr>
                ) : (
                  adminUsers.map((admin) => (
                    <tr key={admin.id}>
                      <td>{admin.id}</td>
                      <td>{admin.username}</td>
                      <td>{admin.email || 'N/A'}</td>
                      <td>
                        <span className={`role-badge role-${admin.role}`}>
                          {admin.role}
                        </span>
                      </td>
                      <td>
                        {admin.two_factor_auth_enabled ? (
                          <span className="status-healthy">Да</span>
                        ) : (
                          <span className="status-unreachable">Нет</span>
                        )}
                      </td>
                      <td>
                        {admin.is_active ? (
                          <span className="status-healthy">Да</span>
                        ) : (
                          <span className="status-unhealthy">Нет</span>
                        )}
                      </td>
                      <td>
                        {admin.last_login
                          ? new Date(admin.last_login).toLocaleString()
                          : 'Never'}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminUsers;


